<template>
  <el-form
    ref="authRuleForm"
    :model="data"
    :rules="rules"
    label-width="100px"
  >
    <el-form-item
      label="父级权限"
      prop="parent_id"
    >
      <!-- <el-select
        v-model="data.parentid"
        placeholder="请选择"
        clearable
        filterable
        :filter-method="parentFilter"
        @change="parentidChange"
      >
        <el-option v-for="item in parentOptions" :key="item.key" :label="item.display_name | entityToString" :value="item.key" />
      </el-select> -->
      <el-cascader
        :key="casKey"
        :options="optionData"
        :props="{value: 'id', label: 'title', checkStrictly: true}"
        @change="handleChange"
      />
    </el-form-item>
    <el-form-item
      label="名称"
      prop="title"
    >
      <el-input
        v-model.trim="data.title"
        placeholder="请填写权限名称"
      />
    </el-form-item>
    <el-form-item
      label="请求链接"
      prop="url"
    >
      <el-tooltip
        effect="dark"
        content="请求链接默认不用加前缀"
        placement="top"
      >
        <el-input
          v-model.trim="data.url"
          placeholder="请填写请求链接"
        >
          <template slot="prepend">
            <i class="el-icon-link" />
          </template>
        </el-input>
      </el-tooltip>
    </el-form-item>
    <el-form-item
      label="请求方式"
      prop="method"
    >
      <el-select v-model="data.method">
        <el-option
          v-for="ite in methodOptions"
          :key="ite.key"
          :label="ite.display_name"
          :value="ite.key"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="标识"
      prop="slug"
    >
      <el-input
        v-model.trim="data.slug"
        placeholder="请填写标识"
      />
    </el-form-item>
    <el-form-item
      label="权限描述"
      prop="description"
    >
      <el-input
        v-model.trim="data.description"
        type="textarea"
        rows="6"
        placeholder="请填写权限描述"
      />
    </el-form-item>
    <el-form-item
      label="排序"
      prop="sort"
    >
      <el-input
        v-model.trim="data.sort"
        placeholder="请填写排序"
      />
    </el-form-item>
    <el-form-item
      label="鉴定权限"
      prop="is_need_auth"
    >
      <el-radio-group v-model="data.is_need_auth">
        <el-radio :label="1">启用 </el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="status"
    >
      <el-radio-group v-model="data.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="submit"
      >提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  // getRuleChildrenList,
  createRule,
  ruleChildrenList
} from '@/api/authRule'
export default {
  name: 'AuthRuleCreate',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      casKey: Math.random(),
      rules: {
        parent_id: [
          { required: true, message: '父级不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请求链接不能为空', trigger: 'blur' }
        ],
        slug: [
          { required: true, message: '标识不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      },
      data: {
        parent_id: null,
        title: '',
        url: '',
        method: 'GET',
        slug: '',
        description: '',

        sort: 100,

        is_need_auth: 1,

        status: 1
      },
      parentOptions: [
        { key: '0', display_name: '顶级权限' }
      ],
      optionData: [{
        id: 0,
        title: '顶级分组'
      }], // 分组筛选列表
      parentFilterOptions: [],
      methodOptions: [
        { key: 'GET', display_name: 'GET' },
        { key: 'HEAD', display_name: 'HEAD' },
        { key: 'POST', display_name: 'POST' },
        { key: 'PUT', display_name: 'PUT' },
        { key: 'DELETE', display_name: 'DELETE' },
        { key: 'PATCH', display_name: 'PATCH' },
        { key: 'OPTIONS', display_name: 'OPTIONS' }
      ]
    }
  },
  created() {
    // this.initData()
    this.getGroupChildrenList()
  },
  methods: {
    // 获取分组筛选列表
    getGroupChildrenList() {
      this.optionData = [{
        id: 0,
        title: '顶级分组'
      }]
      ruleChildrenList().then(res => {
        this.optionData.push(...res.data.list)
      })
    },
    // 选择回调
    handleChange(e) {
      this.data.parent_id = e[e.length - 1]
    },

    // 清空文本
    resetQueryData() {
      this.data = {
        parent_id: '',
        title: '',
        url: '',
        method: 'GET',
        slug: '',
        description: '',
        sort: 100,
        is_need_auth: 1,
        status: 1
      }
      this.item.dialogVisible = false
    },
    // 提交
    submit() {
      this.$refs.authRuleForm.validate(valid => {
        if (!valid) {
          return false
        }
        createRule(this.data).then(response => {
          this.casKey = Math.random()
          this.$emit('updateList')
          this.resetQueryData()
          this.successTip('添加权限成功', () => {
            if (this.$refs.authRuleForm !== undefined) {
              this.$refs.authRuleForm.resetFields()
            }
            this.item.dialogVisible = false
          })
        })
      })
    },

    // async initData() {
    //   const all = await getRuleChildrenList({
    //     id: 0,
    //     type: 'list'
    //   })

    //   const list = all.data.list

    //   if (list.length > 0) {
    //     list.forEach(item => {
    //       this.parentOptions.push({
    //         key: item.id,
    //         display_name: item.spacer + ' ' + item.title + '【' + item.method + '】'
    //       })
    //     })

    //     this.parentFilterOptions = this.parentOptions
    //   }
    // },
    parentFilter(val) {
      this.data.parentid = val
      if (val) {
        this.parentOptions = this.parentFilterOptions.filter(item => {
          if (!!~item.display_name.indexOf(val) ||
            !!~item.display_name.toUpperCase().indexOf(val.toUpperCase())
          ) {
            return true
          }
        })
      } else {
        this.parentOptions = this.parentFilterOptions
      }
    },
    parentidChange(val) {
      if (val) {
        this.parentOptions = this.parentFilterOptions
      }
    },
    send() {
      console.log('我是send')
      this.getGroupChildrenList()
    }

  }
}
</script>
